import { Injectable } from '@angular/core';
import {
  StatisticService,
  STORE_STATISTIC_KEY
} from '@core/services/statistic.service';
import { Observable } from 'rxjs';
import { GameHockeyPosition, HockeyStatistic } from '@mtgame/core';
import { HOCKEY_PLAYOFF_ROUNDS_IDS, HOCKEY_REGULAR_ROUNDS_IDS } from '@utils/hardcode';

@Injectable()
export class HockeyStatisticService extends StatisticService {
  get statistic$(): Observable<HockeyStatistic[]> {
    return this.store.get(STORE_STATISTIC_KEY);
  }

  async loadStatistic(): Promise<HockeyStatistic[]> {
    const statistic = await this.tournamentApi.getHockeyStatistic(this.filters);

    const isFiltered = Boolean(
      this.filters.tournament_tour || this.filters.playoff_stage || this.filters.playoff_round ||
      this.filters.playoff_id,
    )
    if (this.filters.tournament_round_id && !isFiltered) {
      let minGamesCount: number;
      let minGameTime: number;
      if (HOCKEY_REGULAR_ROUNDS_IDS.includes(this.filters.tournament_round_id)) {
        minGamesCount = 5;
        minGameTime = 300 * 60;
      } else if (HOCKEY_PLAYOFF_ROUNDS_IDS.includes(this.filters.tournament_round_id)) {
        minGamesCount = 3;
        minGameTime = 180 * 60;
      }
      statistic.data = statistic.data.map(item => {
        if (item.leaguePlayer.user.hockeyProfile.position === GameHockeyPosition.goaltender) {
          if ((minGamesCount && item.gamesCount < minGamesCount) ||
            (minGameTime && item.gameTime < minGameTime)
          ) {
            item.newbie = true;
          }
        }
        return item;
      })
    }
    this.store.save(STORE_STATISTIC_KEY, statistic.data);
    return statistic.data;
  }
}
